import React from 'react';
import ReactDOM from 'react-dom';
// import App from './App';
import { RouterApp } from './RouterApp';

ReactDOM.render(
  <>
    <RouterApp />
  </>,
  document.getElementById('root')
);

